"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _BellNotifications = _interopRequireDefault(require("@insided/destination/icons/BellNotifications"));

var _NotificationCenterPanel = _interopRequireDefault(require("./NotificationCenterPanel"));

var _axios = _interopRequireDefault(require("axios"));

var _NotificationCenterItem = require("./NotificationCenterItem");

var _NotificationCenterItemsList = _interopRequireDefault(require("./NotificationCenterItemsList"));

var _NotificationCenterPhrasesPreLoad = _interopRequireDefault(require("./NotificationCenterPhrasesPreLoad"));

var _NotificationCenterEmpty = _interopRequireDefault(require("./NotificationCenterEmpty"));

var _NotificationCenterEndOfList = _interopRequireDefault(require("./NotificationCenterEndOfList"));

var _NotificationCenterSkeleton = _interopRequireDefault(require("./NotificationCenterSkeleton"));

var _NotificationCenterItemSkeleton = _interopRequireDefault(require("./NotificationCenterItemSkeleton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FIVE_MINUTES = 5 * 60 * 1000;

var NotificationCenter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NotificationCenter, _Component);

  var _super = _createSuper(NotificationCenter);

  function NotificationCenter() {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationCenter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadMoreRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "triggerRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timer", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isNotificationCenterOpen: false,
      notifications: [],
      newNotifications: [],
      recentNotifications: [],
      isLoading: false,
      isLoadingMore: false,
      notificationsCounter: 0,
      isCounterLoading: false,
      tokens: [],
      isEndOfList: false,
      wasOpened: false,
      isSomeNotificationsUnread: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLoadMoreObserve", function () {
      if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
        var lazyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var loadMoreComponent = entry.target;

              if (loadMoreComponent.classList.contains('is-shown')) {
                _this.loadMoreNotifications();
              }
            }
          });
        });
        lazyObserver.observe(_this.loadMoreRef);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadNotificationsCounter", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                isCounterLoading: true
              });

              _context.next = 3;
              return _axios.default.get('/notificationcenter/counter');

            case 3:
              result = _context.sent;

              _this.setState({
                notificationsCounter: result.data.newItems,
                isCounterLoading: false
              });

              _this.timer = setTimeout(_this.loadNotificationsCounter, FIVE_MINUTES);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadNotifications", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var result, _this$getSortedNotifi, newItems, recentItems, isSomeNotificationsUnread;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return _axios.default.get('/notificationcenter/messages?paginated=1');

            case 4:
              result = _context2.sent;
              _this$getSortedNotifi = _this.getSortedNotifications(result.data.items), newItems = _this$getSortedNotifi.newItems, recentItems = _this$getSortedNotifi.recentItems;
              isSomeNotificationsUnread = result.data.items.some(function (notification) {
                return notification.status !== _NotificationCenterItem.NotificationStatus.Read;
              });

              _this.setState({
                notifications: result.data.items,
                newNotifications: newItems,
                recentNotifications: recentItems,
                isLoading: false,
                tokens: [result.data.resumeToken],
                isEndOfList: !result.data.resumeToken,
                isSomeNotificationsUnread: isSomeNotificationsUnread
              });

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);

              _this.setState({
                isLoading: false,
                isEndOfList: true
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadMoreNotifications", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$state, notifications, newNotifications, recentNotifications, tokens, isLoadingMore, result, _this$getSortedNotifi2, newItems, recentItems, allNotifications, isSomeNotificationsUnread;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state = _this.state, notifications = _this$state.notifications, newNotifications = _this$state.newNotifications, recentNotifications = _this$state.recentNotifications, tokens = _this$state.tokens, isLoadingMore = _this$state.isLoadingMore;

              if (!isLoadingMore) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              _this.setState({
                isLoadingMore: true
              });

              _context3.prev = 4;
              _context3.next = 7;
              return _axios.default.get("/notificationcenter/messages?paginated=1&token=".concat(tokens.at(-1)));

            case 7:
              result = _context3.sent;
              _this$getSortedNotifi2 = _this.getSortedNotifications(result.data.items), newItems = _this$getSortedNotifi2.newItems, recentItems = _this$getSortedNotifi2.recentItems;
              allNotifications = notifications.concat(result.data.items);
              isSomeNotificationsUnread = allNotifications.some(function (notification) {
                return notification.status !== _NotificationCenterItem.NotificationStatus.Read;
              });

              _this.setState({
                notifications: allNotifications,
                newNotifications: newNotifications.concat(newItems),
                recentNotifications: recentNotifications.concat(recentItems),
                isLoadingMore: false,
                tokens: tokens.concat([result.data.resumeToken]),
                isEndOfList: !result.data.resumeToken,
                isSomeNotificationsUnread: isSomeNotificationsUnread
              });

              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);

              _this.setState({
                isLoadingMore: false,
                isEndOfList: true
              });

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSortedNotifications", function (notifications) {
      return {
        newItems: notifications.filter(function (notification) {
          return Object.values(_NotificationCenterItem.NotificationReason).includes(notification.reason);
        }).filter(function (notification) {
          return notification.status === _NotificationCenterItem.NotificationStatus.New;
        }).map(function (notification) {
          return _objectSpread(_objectSpread({}, notification), {}, {
            reason: notification.reason.includes(_NotificationCenterItem.NotificationReason.mention) ? _NotificationCenterItem.NotificationReason.mention : notification.reason
          });
        }),
        recentItems: notifications.filter(function (notification) {
          return Object.values(_NotificationCenterItem.NotificationReason).includes(notification.reason);
        }).filter(function (notification) {
          return notification.status !== _NotificationCenterItem.NotificationStatus.New;
        }).map(function (notification) {
          return _objectSpread(_objectSpread({}, notification), {}, {
            reason: notification.reason.includes(_NotificationCenterItem.NotificationReason.mention) ? _NotificationCenterItem.NotificationReason.mention : notification.reason
          });
        })
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetNotificationStatus", function () {
      _this.setState(function (state) {
        var notifications = state.notifications.map(function (notification) {
          return _objectSpread(_objectSpread({}, notification), {}, {
            status: notification.status === _NotificationCenterItem.NotificationStatus.New ? _NotificationCenterItem.NotificationStatus.Seen : notification.status
          });
        });

        var _this$getSortedNotifi3 = _this.getSortedNotifications(notifications),
            newItems = _this$getSortedNotifi3.newItems,
            recentItems = _this$getSortedNotifi3.recentItems;

        return _objectSpread(_objectSpread({}, state), {}, {
          notifications: notifications,
          newNotifications: newItems,
          recentNotifications: recentItems
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openNotificationCenter", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$state2, newNotifications, notificationsCounter, wasOpened, noUpdatesAfterInitialLoad;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$state2 = _this.state, newNotifications = _this$state2.newNotifications, notificationsCounter = _this$state2.notificationsCounter, wasOpened = _this$state2.wasOpened;
              noUpdatesAfterInitialLoad = newNotifications.length === notificationsCounter && !wasOpened;

              _this.setState({
                isNotificationCenterOpen: true,
                wasOpened: true
              });

              if (!(notificationsCounter && !noUpdatesAfterInitialLoad)) {
                _context4.next = 7;
                break;
              }

              _this.setState({
                notificationsCounter: 0,
                tokens: [],
                notifications: [],
                newNotifications: [],
                recentNotifications: [],
                isEndOfList: false
              });

              _context4.next = 7;
              return _this.loadNotifications();

            case 7:
              if (!notificationsCounter) {
                _context4.next = 11;
                break;
              }

              _this.setState({
                notificationsCounter: 0
              }); // hide badge with counter since new messages are just read


              _context4.next = 11;
              return _axios.default.post('/notificationcenter/reset').catch(function (e) {
                console.error(e);
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeNotificationPanel", function () {
      _this.setState({
        isNotificationCenterOpen: false
      });

      _this.resetNotificationStatus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "markAllNotificationsRead", function () {
      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          notifications: state.notifications.map(function (notification) {
            return _objectSpread(_objectSpread({}, notification), {}, {
              status: _NotificationCenterItem.NotificationStatus.Read
            });
          }),
          newNotifications: state.newNotifications.map(function (notification) {
            return _objectSpread(_objectSpread({}, notification), {}, {
              status: _NotificationCenterItem.NotificationStatus.Read
            });
          }),
          recentNotifications: state.recentNotifications.map(function (notification) {
            return _objectSpread(_objectSpread({}, notification), {}, {
              status: _NotificationCenterItem.NotificationStatus.Read
            });
          }),
          isSomeNotificationsUnread: false
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "markAllAsRead", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.markAllNotificationsRead();

              _context5.next = 3;
              return _axios.default.post("/notificationcenter/mark-all-read").catch(function (e) {
                console.error(e);
              });

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "changeNotificationStatusInArray", function (notifications, notificationId) {
      return notifications.map(function (notification) {
        var newStatus = notification.status === _NotificationCenterItem.NotificationStatus.Read ? _NotificationCenterItem.NotificationStatus.Seen : _NotificationCenterItem.NotificationStatus.Read;
        return _objectSpread(_objectSpread({}, notification), {}, {
          status: notification.id === notificationId ? newStatus : notification.status
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onStatusChange", function (id) {
      if (!id) return;

      _this.setState(function (state) {
        var isNewItemChanged = state.newNotifications.some(function (notification) {
          return notification.id === id;
        });
        var isRecentItemChanged = state.recentNotifications.some(function (notification) {
          return notification.id === id;
        });

        var notifications = _this.changeNotificationStatusInArray(state.notifications, id);

        var isSomeNotificationsUnread = notifications.some(function (notification) {
          return notification.status !== _NotificationCenterItem.NotificationStatus.Read;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          notifications: notifications,
          newNotifications: isNewItemChanged ? _this.changeNotificationStatusInArray(state.newNotifications, id) : state.newNotifications,
          recentNotifications: isRecentItemChanged ? _this.changeNotificationStatusInArray(state.recentNotifications, id) : state.recentNotifications,
          isSomeNotificationsUnread: isSomeNotificationsUnread
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(NotificationCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadNotificationsCounter();
      this.loadNotifications();
      this.setLoadMoreObserve();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$triggerRef$curr,
          _this$triggerRef;

      var _this$state3 = this.state,
          isNotificationCenterOpen = _this$state3.isNotificationCenterOpen,
          notifications = _this$state3.notifications,
          newNotifications = _this$state3.newNotifications,
          recentNotifications = _this$state3.recentNotifications,
          isLoading = _this$state3.isLoading,
          notificationsCounter = _this$state3.notificationsCounter,
          isEndOfList = _this$state3.isEndOfList,
          isSomeNotificationsUnread = _this$state3.isSomeNotificationsUnread;
      return (0, _preact.h)("div", {
        className: "notification-center",
        "data-bounded-context": "Notification Center",
        "data-entity": "Notification Center"
      }, (0, _preact.h)("button", {
        ref: this.triggerRef,
        type: "button",
        className: (0, _classnames.default)('btn btn--secondary btn--notification-center'),
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!isNotificationCenterOpen) {
                    _context6.next = 4;
                    break;
                  }

                  _context6.t0 = _this2.closeNotificationPanel();
                  _context6.next = 7;
                  break;

                case 4:
                  _context6.next = 6;
                  return _this2.openNotificationCenter();

                case 6:
                  _context6.t0 = _context6.sent;

                case 7:
                  return _context6.abrupt("return", _context6.t0);

                case 8:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        })),
        "data-track-type": "click",
        "data-element-name": "Notification Center",
        "data-has-notifications": "".concat(!!notificationsCounter)
      }, (0, _preact.h)(_BellNotifications.default, {
        width: 16,
        height: 16
      }), notificationsCounter > 0 ? (0, _preact.h)("span", {
        className: "notification-center__badge"
      }, notificationsCounter) : null), (0, _preact.h)(_NotificationCenterPhrasesPreLoad.default, null), (0, _preact.h)(_NotificationCenterPanel.default, {
        isOpen: isNotificationCenterOpen,
        triggerRef: (_this$triggerRef$curr = (_this$triggerRef = this.triggerRef) === null || _this$triggerRef === void 0 ? void 0 : _this$triggerRef.current) !== null && _this$triggerRef$curr !== void 0 ? _this$triggerRef$curr : null,
        closeNotificationPanel: this.closeNotificationPanel,
        markAllAsRead: this.markAllAsRead,
        showViewAllLink: !isLoading && !!(notifications !== null && notifications !== void 0 && notifications.length),
        isSomeNotificationsUnread: isSomeNotificationsUnread
      }, isLoading ? (0, _preact.h)(_NotificationCenterSkeleton.default, null) : null, !isLoading && notifications !== null && notifications !== void 0 && notifications.length ? (0, _preact.h)("div", null, (0, _preact.h)(_NotificationCenterItemsList.default, {
        newNotifications: newNotifications,
        recentNotifications: recentNotifications,
        onStatusChange: this.onStatusChange
      }), isEndOfList ? (0, _preact.h)(_NotificationCenterEndOfList.default, null) : null) : null, (0, _preact.h)(_NotificationCenterItemSkeleton.default, {
        isShown: !isEndOfList && !!(notifications !== null && notifications !== void 0 && notifications.length),
        setRef: function setRef(node) {
          _this2.loadMoreRef = node;
        }
      }), !isLoading && !(notifications !== null && notifications !== void 0 && notifications.length) ? (0, _preact.h)(_NotificationCenterEmpty.default, null) : null));
    }
  }]);
  return NotificationCenter;
}(_preact.Component);

var _default = NotificationCenter;
exports.default = _default;